import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import MultiSelector from '../../MultiSelector';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import InternalError from '../../generales/InternalError';
import { ca } from 'date-fns/locale';
const ModalCreateHostSNMP =({buscar_cis,setManttoData,ManttoData,handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [LatValid,setLatValid]=useState(true)
    const [LonValid,setLonValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)



    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    // const dataCriticalities=useFetch('cassia/group_types','','','GET',server)
    // console.log(dataCriticalities)


    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="0")?"1":"0"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="snmp_ip"){
            if(value==""){
                setIpValid(true)
            }else{
                setIpValid(validateIp(value))
            }
          }
    }



    useEffect(()=>{
     
          if( ManttoData.host=="" || ManttoData.name=="" || IpValid==false || LatValid==false || LonValid==false  || ManttoData.ip=="" ||
             ManttoData.location_lat==""  || ManttoData.location_lon==""
          
          ){
              setDisabled(true)
          }else{
              setDisabled(false)
          }
    },[ManttoData])


    const Registrar=()=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=groupSelected.hostid
        }

        let  body ={}


        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/hosts/'+url_add, {
             method: method,  
             headers: {
                "Accept": "application/json",
               // 'Content-Type': 'application/json',
               'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(ManttoData),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
            
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
             // console.log(data1);
             closCreateCisModal()
           setRegisterIsValid(true)
           buscar_cis()
           const timer = setTimeout(() => {
             setRegisterIsValid(false)
             setEditActive(false)
             closCreateCisModal()
           }, 3000);
         
           } else {
             const data1 = await response.json();
             handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
             
              setManttoData({type_id:0,name:""})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
          //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }

    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                  
               setIpValid(true)
               }else{
                   
                   setMsgError("La IP ya existe")
                   setIpValid(false)
               }

               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const changeMultiOption=(option,index,titulo)=>{
      let attr=""
      if(titulo=="Grupos"){
        attr="groupids"
      }

        setManttoData((prevState)=>{
            return {
                ...prevState,
                [attr]:option.map(item => item.value)
            }
            
        })
    }
    const changeOption=(option,index)=>{
        
       

        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['snmp_version']:(parseInt(option.value))
            }
            
        })
        // setManttoRelation(option.value)
            
    }

    const validarLatitud = (lat) => {
      return lat >= -90 && lat <= 90 && lat.toString().includes('.');
    };
    const validarLongitud = (lng) => {
      return lng >= -180 && lng <= 180 && lng.toString().includes('.');
    };

    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            // buscar_host(ip)
        }else{
            
            setMsgError("Direccion ip no valida")
            
        }
        return result;
    };
    const [resultList,setResultList]=useState([])


    //   console.log(resultList)

    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const [listSelected,setListSelected]=useState(1)
    const [internalError,setInternalError]=useState(false)
    const hadleChangeList=(e)=>{
      setInternalError(false)
      setListSelected(e)
  }

    const reqField=()=>{
      return(
        <p className='reqField-gs'>
          *
        </p>
      )
    }
    const levelsActual = dataUsers.data.map(obj => obj.level)
    const levels=[
      {
        id:0,
        name:'',
        cassia_criticality_id:0
    },
      {
          id:1,
          name:1,
          cassia_criticality_id:1
      },
      {
          id:2,
          name:2,
          cassia_criticality_id:2
      },
      {
          id:3,
          name:3,
          cassia_criticality_id:3
      },
      {
          id:4,
          name:4,
          cassia_criticality_id:4
      },
      {
          id:5,
          name:5,
          cassia_criticality_id:5
      }
  ]


    const {
      host,
      name,
      proxy_id,
      description,
      status,
      device_id,
      alias,
      location_lat,
      location_lon,
      serialno_a,
      macaddress_a,
      brand_id,
      model_id,
      agent_ip,
      agent_port,
      snmp_ip,
      snmp_port,
      snmp_version,
      snmp_community,
      groupids,
      zona_groupid}=ManttoData;

    const infoOnly = groupSelected?.infoOnly || false;
    return (
        //********************************************************** */
        <>
            <div className="form-GS-box" style={{ pointerEvents: infoOnly ? 'none' : 'auto', opacity: infoOnly ? 0.8 : 1 }}> 
                                   
                                   
                                   
                                   <div className="user-box-GS"  style={{height:'13%'}}>
                                   <input required name="snmp_ip"  type="text" value={snmp_ip}
                                   onChange={handleChange}  />
                                       <label className='label-GS  '>{'SNMP IP '}</label>
                                       {
                                           IpValid?'':<span className='form-msg-error' style={{bottom:'0%'}}> {msgError}</span>
                                       }
                                   </div>
                                  
                                   <div className="user-box-GS disabled"  style={{height:'13%'}}>
                                       {
                                           (IpValid && snmp_ip!="")?'':
                                           <div className='blockfield-gs'>
                                           {capitalizeFirstLetter(lang[languaje]['campoBloqueadoIP'])}
                                           </div>
                                       }
                                   {
                                           
                                           <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={'TODOS'}  opt_de={snmp_version} origen={'Admin'} data={levels}   titulo='Severity' selectFunction={changeOption} index={0}></SelectorAdmin>

                                       }
                                       <label className='label-GS  '>{'SNMP Version'}</label>
                                       
                                   </div>
                                   
                                   <div className="user-box-GS"  style={{height:'13%'}}>
                                   {
                                           (IpValid && snmp_ip!="")?'':
                                           <div className='blockfield-gs'>
                                          {capitalizeFirstLetter(lang[languaje]['campoBloqueadoIP'])}
                                           </div>
                                       }
                                   <input required name="snmp_community"  type="text" value={snmp_community}
                                   onChange={handleChange}  />
                                       <label className='label-GS  '>{'SNMP Community'}</label>
                                       
                                   </div>
                                   
                                  
                                  
                                  
                                  
                                   
                                   
                                   <div className="user-box-GS" style={{height:'13%', pointerEvents: 'auto'}}>
                                       {
                                           (loading)?<LoadSimple></LoadSimple>
                                           :
                                           infoOnly ? (
                                             <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['cerrar'] || 'Cerrar')}  action={closCreateCisModal}/>
                                           ) : (
                                             <>
                                             <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                             <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                             </>
                                           )
                                       }
                                           
                                  
                                       
                                   </div>
                               </div>
        </>
    );
}

export default ModalCreateHostSNMP